import { render, staticRenderFns } from "./changeChannel.vue?vue&type=template&id=0d9f098d&scoped=true"
import script from "./changeChannel.vue?vue&type=script&lang=js"
export * from "./changeChannel.vue?vue&type=script&lang=js"
import style0 from "./changeChannel.vue?vue&type=style&index=0&id=0d9f098d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9f098d",
  null
  
)

export default component.exports